import React, { useState } from 'react';
import { connect } from 'react-redux';

import ProfileSidebar from '../../Components/Profile/ProfileSidebar';
import SpecialityModal from '../../Components/UI/Modal/SpecialityModal';
import RegionModal from './RegionModal';
import { artisanRegistrationLabel } from '../../Utils/artisanStatus';
import { regionLabel } from '../../Config/franceRegions';

const label = (value) => value
  ? value.charAt(0).toUpperCase() + value.slice(1)
  : 'Non renseigné';

const BoutiqueProfile = ({ profile }) => {
  const [showSpeciality, setShowSpeciality] = useState(false);
  const [showRegion, setShowRegion] = useState(false);

  return (
    <>
      <ProfileSidebar
        profile={profile}
        editPath="/profileartisan"
        showRating
        details={[
          { label: 'Spécialité', value: label(profile.speciality), onClick: () => setShowSpeciality(true) },
          { label: 'Région', value: regionLabel(profile.artisan_region), onClick: () => setShowRegion(true) },
          {
            label: 'Inscription',
            value: artisanRegistrationLabel(profile.registration_status),
          },
          { label: 'Projets évalués', value: String(Number(profile.total_num_jobs) || 0) },
        ]}
      />
      <SpecialityModal
        showModal={showSpeciality ? 'open' : 'close'}
        handleClick={() => setShowSpeciality(false)}
      />
      <RegionModal
        showModal={showRegion ? 'open' : 'close'}
        handleClick={() => setShowRegion(false)}
      />
    </>
  );
};

const mapStateToProps = ({ firebase }) => ({ profile: firebase.profile || {} });
export default connect(mapStateToProps)(BoutiqueProfile);
